import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { mergeStyles } from '@fluentui/react';
import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Link } from 'react-router-dom';
import { milestoneLiStyle } from '../../app/common/styles/CommonStyleObjects';
import { IMilestoneDashboardCardItem } from '../../utils/types/IMilestoneDashboardCardItem';
import VerticalScrollbarWrapper from '../common/DetailsLists/VerticalScrollbarWrapper';

interface IMilestoneCardList {
  milestones: IMilestoneDashboardCardItem[];
  milestoneDateStyle: string;
}

const listStyle = mergeStyles({
  paddingLeft: 0,
});

const useStyles = makeStyles({
  dateColumn: { width: '50px' },
});

const MilestoneCardList = ({ milestones, milestoneDateStyle }: IMilestoneCardList): JSX.Element => {
  const classes = useStyles();
  return (
    <VerticalScrollbarWrapper>
      <ul className={listStyle}>
        {milestones.map((milestone: IMilestoneDashboardCardItem) => {
          return (
            <li key={milestone.id} className={milestoneLiStyle}>
              <Stack horizontal tokens={{ childrenGap: 5 }}>
                <Stack className={classes.dateColumn}>
                  <strong>
                    <span>{`${milestone.dueDate}`}</span>
                  </strong>
                </Stack>
                <Stack className={milestoneDateStyle}>
                  <strong>{`${milestone.companyCode} - ${milestone.sapName}`}</strong>
                  <Link
                    to={`/companies/${milestone.companyCode}/processes/${milestone.processTypeUri}/${milestone.processId}`}
                  >
                    {milestone.title}
                  </Link>
                </Stack>
              </Stack>
            </li>
          );
        })}
      </ul>
    </VerticalScrollbarWrapper>
  );
};
export default MilestoneCardList;
